export function LoadingIcon() {
  return (
    <div className="w-full h-[calc(100vh-87px)] relative flex items-center">
      <div className="loader" />
    </div>
  );
}

export default LoadingIcon;
